import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

export interface EditorOptions {
	menubar: boolean;
	plugins: string[];
	toolbar: string;
	autoresize_bottom_margin?: number;
}
@Component({
	selector: 'app-editor',
	templateUrl: './editor.component.html',
	imports: [CKEditorModule, FormsModule, NgClass],
	styles: `
		.disabled {
			opacity: 0.7;
		}
	`,
	standalone: true,
})
export class EditorComponent {
	@Input() value = '';
	@Input() disabled = false;

	@Output() valueChange = new EventEmitter<string>();

	readonly Editor = ClassicEditor;

	emitChange(): void {
		this.valueChange.emit(this.value);
	}
}
